export default __webpack_public_path__ + "static/media/use-case-block-1.be5aa749.png";